import { ExtendedButtonProps } from "@components/general/Button/Button";
import { forwardRef } from "react";
import { NavigationToggleBase } from "@components/navigation/NavigationToggleBase";
import { useWorkspaceContext } from "@state/workspaceContext";

export const DefaultNavigationDropdownToggle = forwardRef(
    ({ onClick }: ExtendedButtonProps, ref) => {
        const { activeWorkspace } = useWorkspaceContext();

        return (
            <NavigationToggleBase
                onClick={onClick}
                text={activeWorkspace?.name ?? ""}
                ref={ref as any}
            />
        );
    },
);
